/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import { useState } from 'react';

import { useCancelChangeOrderAction } from '@/Client/State/useCancelChangeOrderAction';
import { ConfirmActionDialog } from '@/Client/Widgets/ConfirmActionDialog';
import { MAIN_NAVIGATION_BUTTON_STYLES } from './mainNavigationStyles';

export const BUTTON_TEXT = 'Cancel Change Order';
export const CONFIRM_ACTION_MESSAGE = 'Are you sure you want to cancel this change order? This action cannot be undone.';
export const CONFIRM_ACTION_LABEL = `Yes, ${BUTTON_TEXT}`;
export const CONFIRM_ACTION_LABEL_NOT_READY = 'Saving changes…';

export const CancelChangeOrderHeaderAction = ({ buttonStyle = MAIN_NAVIGATION_BUTTON_STYLES.secondary }: { buttonStyle?: SerializedStyles }) => {
  const { canCancel, isReadyToCancel, cancelChangeOrder } = useCancelChangeOrderAction();
  const [modalOpen, setModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!canCancel) return null;

  const confirmCancel = async () => {
    setSubmitting(true);
    try {
      await cancelChangeOrder();
      setModalOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button type={'button'} css={buttonStyle} onClick={() => setModalOpen(true)}>
        {BUTTON_TEXT}
      </button>
      {modalOpen
        ? (
          <ConfirmActionDialog
            title={BUTTON_TEXT}
            message={CONFIRM_ACTION_MESSAGE}
            confirmLabel={isReadyToCancel ? CONFIRM_ACTION_LABEL : CONFIRM_ACTION_LABEL_NOT_READY}
            confirmDisabled={!isReadyToCancel}
            busy={submitting}
            onConfirm={confirmCancel}
            onCancel={() => setModalOpen(false)}
          />
        )
        : null}
    </>
  );
};
